
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/make/[id]",
      function () {
        return require("private-next-pages/make/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/make/[id]"])
      });
    }
  